'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactScroll = require('react-scroll');
var _reactSelect = require('react-select');var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _checkIsForeignAddress = require('../../helpers/checkIsForeignAddress');var _checkIsForeignAddress2 = _interopRequireDefault(_checkIsForeignAddress);
var _propertyDetails = require('../../redux/modules/propertyDetails');
var _components = require('../../components');
var _Slider = require('../../components/HomePagePropertiesCarousel/components/Slider');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _services = require('../../services');
var _messageModal = require('../../redux/modules/messageModal');
var _myProjects = require('../../redux/modules/myProjects');
var _constants = require('./constants');
var _constants2 = require('../../constants');

var _myProjects2 = require('./myProjects.scss');var styles = _interopRequireWildcard(_myProjects2);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Styles
var
MyProjects = function (_Component) {_inherits(MyProjects, _Component);function MyProjects() {var _temp, _this, _ret;_classCallCheck(this, MyProjects);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      search_status: false,
      search_location: 'all',
      rowsOnPage: { value: 10, label: 10 },
      selected: 1 }, _this.



























    getPagination = function (name) {
      try {
        var selectedPages = JSON.parse(_constants2.storage.value.getItem(name));

        if (selectedPages) {
          _this.setState({ rowsOnPage: selectedPages });
        }
      } catch (e) {
        console.error('Failed to read ' + name + ' from localStorage');
      }
    }, _this.

    scrollTo = function () {var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'anchor-top';var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _reactScroll.scroller.scrollTo(element, Object.assign({
        duration: 500,
        smooth: true,
        offset: -55 },
      options));

    }, _this.

    handleClick = function (evt) {
      var id = (0, _get2.default)(evt, 'currentTarget.dataset.id');
      _this.openDetailsHandler(evt, id);
    }, _this.

    scrollToTop = function () {
      if (_this.props.isMobile) {
        setTimeout(function () {return _this.scrollTo();}, 501);
      } else {
        _this.scrollTo();
      }
    }, _this.

    handleGoTo = function (val) {
      if (!Number.isNaN(val) && val >= 0) {
        _this.props.setCurrentPaginationStep(val);
        _this.setState({ selected: val });
      }
    }, _this.
    handleBack = function () {
      var step = _this.props.currentPaginationStep - _this.state.rowsOnPage.value;
      _this.props.setCurrentPaginationStep(step > 1 ? step : 1);
      if (document && step >= 1) {
        _this.scrollToTop();
      }
    }, _this.

    changePagination = function (value) {
      _this.setState({ rowsOnPage: value });
      _constants2.storage.value.setItem('rows-on-my-projects-page', JSON.stringify(value));
    }, _this.

    openDetailsHandler = function (evt, propertyId) {var _evt$target =
      evt.target,classList = _evt$target.classList,parentElement = _evt$target.parentElement;

      var isFavoriteIcon = classList.contains('favoriteToggler');
      var isArrowIcon = classList.contains(_Slider.homeCarouselArrowClassName) ||
      parentElement.classList.contains(_Slider.homeCarouselArrowClassName);

      if (isArrowIcon || isFavoriteIcon) {
        return;
      }

      _this.openDetails(evt, propertyId);
    }, _this.

    handleChangeStatus = function (_ref) {var value = _ref.value;
      _this.setState({ search_status: value });
      _this.props.setCurrentPaginationStep(1);
    }, _this.

    handleChangeLocation = function (_ref2) {var value = _ref2.value;
      _this.setState({ search_location: value });
      _this.props.setCurrentPaginationStep(1);
    }, _this.

    openDetails = function (evt, propertyId) {
      var location = 'project_details';
      var entityType = 'project';
      var route = (0, _appendLocale2.default)(
      _this.props.locale, '/' +
      location + '/' + propertyId);


      if (evt.ctrlKey || evt.metaKey) {
        window.open(route);
      } else if (_this.props.isMobile) {
        _reactRouter.browserHistory.push(route);
      } else {
        _reactRouter.browserHistory.push({
          pathname: (0, _appendLocale2.default)(_this.props.locale, '/profile/my_projects'),
          query: { id: entityType + '_' + propertyId } });

        _this.props.openDetailsPopup({ propertyId: propertyId, entityType: entityType });
      }

      _services.AnalyticsEventService.createPropertyEvent({ propertyId: propertyId, action: _constants2.analyticsEventAction.VIEW });
    }, _this.

    handleForward = function (data) {
      var step = _this.props.currentPaginationStep + _this.state.rowsOnPage.value;
      if (step <= data.length) {
        _this.props.setCurrentPaginationStep(step);

        if (document) {
          _this.scrollToTop();
        }
      }
    }, _this.

    renderSelectStatus = function () {
      var translate = _this.props.translate('myProjects');
      var values = _constants.OPTIONS_STATUS.map(function (_ref3) {var title = _ref3.title,value = _ref3.value;return {
          label: translate(title),
          selected: false,
          value: value };});


      return (
        _react2.default.createElement(_components.OMGenericSelect, {
          options: values,
          value: _this.state.search_status,
          onChange: _this.handleChangeStatus }));


    }, _this.

    renderSelectLocation = function () {
      var translate = _this.props.translate('myProjects');
      var values = _constants.OPTIONS_LOCATION.map(function (_ref4) {var title = _ref4.title,value = _ref4.value;return {
          label: translate(title),
          selected: false,
          value: value };});


      return (
        _react2.default.createElement(_components.OMGenericSelect, {
          options: values,
          value: _this.state.search_location,
          onChange: _this.handleChangeLocation }));


    }, _this.




















































    renderPropertyItem = function (project) {var _this$props =







      _this.props,locale = _this$props.locale,userToken = _this$props.userToken,translate = _this$props.translate,isMobile = _this$props.isMobile,isRtl = _this$props.isRtl,myProjects = _this$props.myProjects;

      return (
        _react2.default.createElement('div', { key: project.id, 'data-id': project.id, className: styles.item, onClick: _this.handleClick },
          _react2.default.createElement(_components.MyProjectCard, {
            locale: locale,
            userToken: userToken,
            translate: translate,
            isMobile: isMobile,
            isRtl: isRtl,
            myProjects: myProjects,
            openMessageModal: _this.props.openMessageModal,
            hideMessageModal: _this.props.hideMessageModal,
            deactivateProject: _this.props.deactivateProject,
            project: project })));



    }, _temp), _possibleConstructorReturn(_this, _ret);}MyProjects.prototype.componentDidMount = function componentDidMount() {this.getPagination('rows-on-my-projects-page');this.props.myProject({ token: this.props.userToken });};MyProjects.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref5) {var myProjects = _ref5.myProjects;if (myProjects.error && myProjects.error !== this.props.myProjects.error) {this.props.openMessageModal({ message: _react2.default.createElement('div', { className: 'contentMessage' }, _react2.default.createElement('div', null, _react2.default.createElement('p', null, this.props.translate('myProjects', 'errorMessage')), _react2.default.createElement('button', { className: 'btn btn-primary', onClick: this.props.hideMessageModal }, this.props.translate('contactUsPage', 'ok')))) });}};MyProjects.prototype.renderPagination = function renderPagination(data) {var _this2 = this;var _props = this.props,translate = _props.translate,currentPaginationStep = _props.currentPaginationStep;var rowsOnPage = this.state.rowsOnPage;var total = data.length;var nextStart = currentPaginationStep + rowsOnPage.value - 1;var lastProperty = nextStart < total ? nextStart : total;var handleForward = function handleForward() {return _this2.handleForward(data);};var desktopPagination = _react2.default.createElement('div', { className: styles.paginationBlock }, _react2.default.createElement('div', { className: styles.navigateBtn }, _react2.default.createElement('button', { onClick: handleForward, className: styles.forwardBtn }, _react2.default.createElement('span', { className: 'icon-back' })), _react2.default.createElement('button', { onClick: this.handleBack, className: styles.backBtn }, _react2.default.createElement('span', { className: 'icon-back' }))), _react2.default.createElement('span', null, currentPaginationStep + '-' + lastProperty + ' ' + translate('managePage', 'of') + ' ' + total), _react2.default.createElement('div', { className: styles.inputSection }, _react2.default.createElement('span', null, translate('managePage', 'goTo')), _react2.default.createElement('div', { className: styles.inputWrapper }, _react2.default.createElement('input', { type: 'number', value: this.state.selected, onChange: function onChange(val) {return _this2.handleGoTo(+val.target.value);} }))), _react2.default.createElement('div', { className: styles.inputSection }, _react2.default.createElement('span', { className: styles.showRows }, translate('managePage', 'showRows')), _react2.default.createElement(_reactSelect2.default, { name: 'rows-on-my-projects-page', value: this.state.rowsOnPage, options: _constants.OPTIONS_PAGINATION, onChange: this.changePagination, clearable: false, searchable: false })));var mobilePagination = _react2.default.createElement('div', { className: styles.paginationBlock }, _react2.default.createElement('button', { onClick: handleForward, className: styles.forwardBtn }, _react2.default.createElement('span', { className: 'icon-back' })), _react2.default.createElement('span', null, currentPaginationStep + '-' + lastProperty + ' ' + translate('managePage', 'of') + ' ' + total), _react2.default.createElement('button', { onClick: this.handleBack, className: styles.backBtn }, _react2.default.createElement('span', { className: 'icon-back' })));return this.props.isMobile ? mobilePagination : desktopPagination;};MyProjects.prototype.

  render = function render() {var _props2 =
    this.props,translate = _props2.translate,_props2$myProjects = _props2.myProjects,loading = _props2$myProjects.loading,data = _props2$myProjects.data;var _state =
    this.state,search_status = _state.search_status,search_location = _state.search_location;
    var firstIndex = this.props.currentPaginationStep - 1;

    var filteredStatusData = data && data.filter(function (item) {
      if (search_status === 'all') {return true;}
      if (!search_status && !item.is_deactivated) {return true;}

      return item.is_deactivated === search_status;
    });

    var filteredLocationData = filteredStatusData && filteredStatusData.filter(function (_ref6) {var address = _ref6.address;
      if (search_location === 'all') {
        return true;
      }

      return search_location === (0, _checkIsForeignAddress2.default)(address);
    });

    return (
      _react2.default.createElement('div', { className: styles.pageWrapper },
        _react2.default.createElement(_reactScroll.Element, { name: 'anchor-top' }),
        _react2.default.createElement('p', { className: styles.title }, translate('myProjects', 'title')),
        _react2.default.createElement('p', { className: styles.underTitle }, translate('myProjects', 'underTitle')),
        _react2.default.createElement('div', { className: styles.searchWrapper },
          _react2.default.createElement('div', { className: styles.search },
            _react2.default.createElement('p', { className: styles.searchTitle }, translate('managePage', 'status')),
            _react2.default.createElement('div', { className: styles.select },
              this.renderSelectStatus())),


          _react2.default.createElement('div', { className: styles.search },
            _react2.default.createElement('p', { className: styles.searchTitle }, translate('myProjects', 'location')),
            _react2.default.createElement('div', { className: styles.select },
              this.renderSelectLocation()))),



        loading ?
        _react2.default.createElement('div', { className: styles.spinnerPosition },
          _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) })) :

        _react2.default.createElement('div', { className: styles.itemWrapper },
          data && filteredLocationData.
          slice(firstIndex, firstIndex + this.state.rowsOnPage.value).
          map(this.renderPropertyItem)),



        data && this.renderPagination(filteredLocationData)));


  };return MyProjects;}(_react.Component);


MyProjects.propTypes = {
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  userToken: _propTypes2.default.string,
  myProject: _propTypes2.default.func,
  deactivateProject: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  myProjects: _propTypes2.default.object,
  isRtl: _propTypes2.default.bool,
  openDetailsPopup: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  setCurrentPaginationStep: _propTypes2.default.func,
  currentPaginationStep: _propTypes2.default.number };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    userToken: (0, _get2.default)(state, 'userAuthentication.data.access_token'),
    myProjects: state.myProjects,
    currentPaginationStep: state.myProjects.currentPaginationStep };};


var mapDispatchToProps = {
  myProject: _myProjects.myProject,
  deactivateProject: _myProjects.deactivateProject,
  openDetailsPopup: _propertyDetails.openDetailsPopup,
  hideMessageModal: _messageModal.hideMessageModal,
  openMessageModal: _messageModal.openMessageModal,
  setCurrentPaginationStep: _myProjects.setCurrentPaginationStep };exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MyProjects);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyProjects/MyProjects.js
// module id = 2932
// module chunks = 0